import { render, staticRenderFns } from "./IpDashboardView.vue?vue&type=template&id=cfdfaaa6&"
import script from "./IpDashboardView.vue?vue&type=script&lang=js&"
export * from "./IpDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./IpDashboardView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports